import React from "react";
import moment from "moment-timezone";
import { TextField } from "material-ui";
import chrono from "chrono-node";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

export const timezoneDelta = (v, tz) =>
  moment.tz.zone(tz).parse(v.toISOString()) -
  moment.tz.zone(moment.tz.guess()).parse(v.toISOString());

const DATE_PICKER_STYLE = {
  display: "inline-block"
};

const TIME_PICKER_STYLE = {
  display: "inline-block",
  marginLeft: 7
};

const CLEAR_STYLE = {
  cursor: "pointer",
  marginLeft: 7,
  color: "#ccc",
  verticalAlign: -6,
  borderBottom: "1px solid #e0e0e0"
};

class DateTimePicker extends React.Component {
  constructor(props) {
    super(props);
  }

  _coerceToDate(v) {
    if (!v) {
      return null;
    }
    return v instanceof Date ? v : new Date(v);
  }

  onChange(typeChanged, changed) {
    if (!changed) {
      return;
    }

    let newValue = moment(
      this.props.value
        ? this._coerceToDate(this.props.value)
        : moment().startOf("day").toDate()
    );

    if (this.props.timezone) {
      newValue = moment(newValue || this.props.value).tz(this.props.timezone);
    } else {
      newValue = newValue.toDate();
    }

    if (this.props.timezone) {
      if (typeChanged === "date") {
        newValue.year(changed.get("year"));
        newValue.month(changed.get("month"));
        newValue.date(changed.get("date"));
      } else if (typeChanged === "time") {
        newValue.hour(changed.get("hours"));
        newValue.minute(changed.get("minutes"));
      }
    } else {
      if (typeChanged === "date") {
        newValue.setFullYear(changed.get("year"));
        newValue.setMonth(changed.get("month"));
        newValue.setDate(changed.get("date"));
      } else if (typeChanged === "time") {
        newValue.setHours(changed.get("hours"));
        newValue.setMinutes(changed.get("minutes"));
      }
    }

    if (this.props.timezone) {
      if (!this.props.useMoment) {
        newValue = newValue.toDate();
      }
    } else if (this.props.useMoment) {
      newValue = moment(newValue);
    }

    this.props.onChange(null, newValue);
  }

  onChangeRaw(typeChanged, v) {
    // Append timezone to Chrono input if missing to ensure consistent parsing
    // of timezone with appropriate offset.
    let tzString = this.props.timezone
      ? moment(this.props.value).tz(this.props.timezone).format("z")
      : undefined;
    if (v.indexOf(tzString) === -1) {
      v += ` ${tzString}`;
    }

    let parsed = chrono.parseDate(v, this.props.value);
    if (parsed) {
      let d = moment(parsed);
      if (this.props.timezone) {
        d = d.tz(this.props.timezone);
      }
      this.onChange(typeChanged, d);
    }
  }

  onBlur(date, event) {
    if (this.datePicker) {
      this.datePicker.setSelected(date, event, false);
    }
    if (this.timePicker) {
      this.timePicker.setSelected(date, event, false);
    }
  }

  render() {
    const isDifferentTimezone =
      !!this.props.timezone && moment.tz.guess() !== this.props.timezone;
    let value =
      this.props.value && moment(this._coerceToDate(this.props.value));
    if (value && this.props.timezone) {
      value = value.tz(this.props.timezone);
    }

    return (
      <div className="eventive-datepicker__wrapper">
        {!this.props.hideDate ? (
          <DatePicker
            selected={value}
            onChange={this.onChange.bind(this, "date")}
            onChangeRaw={(e, v) => this.onChangeRaw("date", v)}
            onBlur={this.onBlur.bind(this, value)}
            placeholderText={this.props.placeholder}
            customInput={<TextField style={{ width: 90 }} />}
            ref={r => {
              this.datePicker = r;
            }}
          />
        ) : null}
        {!this.props.hideTime ? (
          <DatePicker
            selected={value}
            onChange={this.onChange.bind(this, "time")}
            onChangeRaw={(e, v) => this.onChangeRaw("time", v)}
            onBlur={this.onBlur.bind(this, value)}
            showTimeSelect
            showTimeSelectOnly
            timeIntervals={15}
            disabledKeyboardNavigation={true}
            dateFormat={isDifferentTimezone ? "h:mma z" : "h:mma"}
            customInput={
              <TextField style={{ width: isDifferentTimezone ? 100 : 70 }} />
            }
            ref={r => {
              this.timePicker = r;
            }}
          />
        ) : null}
        {!this.props.unclearable && (
          <span
            style={CLEAR_STYLE}
            onTouchTap={() => this.props.onChange(null, null)}
          >
            clear
          </span>
        )}
      </div>
    );
  }
}

export default DateTimePicker;



// WEBPACK FOOTER //
// ./src/app/components/partials/datetime-picker.jsx